import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingContractOrders = function () { return utilBalancing.getBalancing().ContractOrders; };
export var selectBalancingContractOrder = memoize(function (id) {
    return selectBalancingContractOrders().get(id);
});
export var balancingContractOrdersMemoizedFunctions = [
    selectBalancingContractOrders,
    selectBalancingContractOrder,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingContractOrders.ts
// module id = 671
// module chunks = 3